import { AboutUs } from '../../components/AboutUs/AboutUs';

export function About() {
  return (
  <AboutUs/ >
  )
}

